import { Check } from 'lucide-react';

// Existing tax_return.status values only; there is no separate "preparation" state.
const STEPS = [
  { label: 'Questionnaire', states: ['not_started', 'in_progress'] },
  { label: 'Documents', states: ['awaiting_documents'] },
  { label: 'Review', states: ['under_review'] },
  { label: 'Ready for Xero', states: ['ready_for_xero'] },
  { label: 'Completed', states: ['completed'] },
];

export const TaxReturnStepper = ({ status }) => {
  const at = STEPS.findIndex((s) => s.states.includes(status));
  return (
    <ol className="flex flex-wrap items-center gap-x-1 gap-y-2 rounded-lg border border-border bg-card p-3 shadow-card" aria-label="Return progress" data-testid="tax-return-stepper">
      {STEPS.map((s, i) => {
        const state = at < 0 ? 'todo' : i < at || status === 'completed' ? 'done' : i === at ? 'current' : 'todo';
        return (
          <li key={s.label} className="flex items-center gap-1" aria-current={state === 'current' ? 'step' : undefined} data-testid={`tax-step-${i}`}>
            <span className={`flex h-6 w-6 items-center justify-center rounded-full text-xs font-semibold tabular ${state === 'done' ? 'bg-success text-white' : state === 'current' ? 'bg-primary text-primary-foreground ring-4 ring-primary/15' : 'bg-muted text-muted-foreground'}`}>
              {state === 'done' ? <Check className="h-3.5 w-3.5" /> : i + 1}
            </span>
            <span className={`text-sm ${state === 'current' ? 'font-semibold text-foreground' : 'text-muted-foreground'}`}>{s.label}</span>
            {i < STEPS.length - 1 && <span className={`mx-2 hidden h-px w-8 sm:block ${state === 'done' ? 'bg-success' : 'bg-border'}`} />}
          </li>);
      })}
    </ol>
  );
};
